import { Navigate, Outlet } from "react-router-dom";

import { useAuth } from "hooks/useAuth";

const PublicLayout = () => {
  const { isLoggedIn } = useAuth();

  if (isLoggedIn) {
    return <Navigate to="/home" replace={true} />;
  }

  return (
    <>
      <Outlet />
    </>
  );
};

export default PublicLayout;
